<template>
  <el-table-column
    prop="receipt_number"
    sortable="custom"
    label="Bizonylatszám"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.receipt_number }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'receipt_number',
  };
</script>
